import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";

// Connects to data-controller="resumin--form-navigation"
export default class extends Controller {
  static values = {
    backFormId: String,
  };

  connect() {
    CsrfToken(this);
  }

  back(e) {
    e.preventDefault();

    const newForm = document.getElementById(this.backFormIdValue);

    const form = new FormData(this.element);
    for (const [key, value] of form.entries()) {
      // authenticity_tokenは既にnewFormに設定されている値を利用するため、上書きしない
      if (key === "authenticity_token") continue;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      newForm.appendChild(input);
    }

    newForm.requestSubmit();
  }
}
